import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_3 = ["disabled"];
const _hoisted_4 = { class: "" };
const _hoisted_5 = { class: "d-flex align-items-center justify-content-end mt-2" };
const _hoisted_6 = {
    key: 0,
    class: "fs-14 text-blue mr-3"
};
const _hoisted_7 = {
    key: 1,
    class: "fs-14 text-blue mr-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _component_gestore_allegati = _resolveComponent("gestore-allegati");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Allegati interni", -1)),
            _createElementVNode("div", null, [
                (_ctx.zipping)
                    ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-sm btn-green ml-2",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.openGallery(0))),
                        disabled: _ctx.customer.allegatiInterni.length == 0
                    }, " Vedi galleria ", 8, _hoisted_3))
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            (!_ctx.refreshAllegati)
                ? (_openBlock(), _createBlock(_component_gestore_allegati, {
                    key: 0,
                    allegati: _ctx.customer.allegatiInterni,
                    onDownload: _ctx.download,
                    onRemove: _ctx.remove,
                    showForceRemove: true,
                    onForceRemove: _ctx.forceRemove,
                    readonly: _ctx.$store.state.isCollaboratore(),
                    onGallery: _ctx.openGallery
                }, null, 8, ["allegati", "onDownload", "onRemove", "onForceRemove", "readonly", "onGallery"]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
            (_ctx.modified && !_ctx.uploading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Premi salva per aggiornare gli allegati ----> "))
                : _createCommentVNode("", true),
            (_ctx.uploading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Sto caricando i file in background, puoi fare altro mentre aspetti "))
                : _createCommentVNode("", true),
            (!_ctx.uploading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-blue",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.save && _ctx.save(...args)))
                }, " Salva allegati "))
                : _createCommentVNode("", true)
        ])
    ]));
}
